// extracted by mini-css-extract-plugin
export default {"wrapperCheckbox":"TurkishAnindaHavale_wrapperCheckbox__K58Gv","checkbox":"TurkishAnindaHavale_checkbox__bHL55"};